import React, { useEffect, useState } from 'react';
import Prismic from 'prismic-javascript';
//
//
export const usePrismicData = ({ documentType, documentUID }) => {
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const apiEndpoint =
    'https://riffrafffilmssocialmediamanager.cdn.prismic.io/api/v2';
  const Client = Prismic.client(apiEndpoint, {});

  useEffect(() => {
    if (documentType && documentUID) {
      const fetchData = async () => {
        const response = await Client.getByUID(documentType, documentUID);

        if (response) {
          setDoc(response);
          setLoading(false);
        } else {
          setError(true);
          setLoading(false);
        }
      };
      fetchData();
    } else {
      setError(`Missing arguments`);
      setLoading(false);
    }
  }, []);

  return { doc, error, loading };
};
